import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Home} from '../../interfaces/page';

@Component({
  selector: 'app-home-section-events',
  templateUrl: './home-section-events.component.html',
  styleUrls: ['./home-section-events.component.scss']
})
export class HomeSectionEventsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() content: Home;

  constructor() { }

  ngOnInit() {
  }

  focusIframe() {
    setTimeout(() => {
      document.getElementsByTagName('iframe')[0].focus();
    }, 1000);
  }

  ngAfterViewInit() {
    // Needs a weird timeout otherwise works intermittently. 
    // Some sort of race condition maybe.
    setTimeout(() => {
      if (!document.getElementById('gather-loader')) {
        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.src = 'https://gatherhere.com/js/leadform.js';
        script.id = 'gather-loader';
        script.setAttribute('data-advanced', 'true');
        document.body.appendChild(script);
      }
    }, 1000);
  }

  ngOnDestroy() {
    document.getElementById('gather-loader').remove();
  }
}
